/**
 * 公用的起服务配置文件
 */

import Vue from 'vue'
import 'babel-polyfill'
import VueRouter from 'vue-router'
import routers from '@/router'
import stores from '@/store'
import Vuex from 'vuex'
import alert from '@common/utils/alert'
import { profileFn, goLogin } from '@common/utils/pro'
Vue.config.productionTip = false
Vue.use(alert)
Vue.use(Vuex)
Vue.use(VueRouter)
// 初始化vuex
const store = new Vuex.Store(stores)
const origin = window.location.origin
const port = window.location.port

// 初始化router
const router = new VueRouter({
  mode: 'history',
  base: origin.indexOf('ent.') >= 0 || origin.indexOf('e.') >= 0 || port === '8066' ? '/task/' : '/',
  routes: routers,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})

// 导航钩子
router.beforeEach((to, from, next) => {
  if (from.params.profile && from.params.profile.uuid) {
    to.params.profile = from.params.profile

    if (to.meta.title) {
      document.title = to.meta.title
    }

    return next()
  }

  // 判断是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    profileFn((res) => {
      // 如果获取简历成功
      to.params.profile = { ...(res.profile || res.result), permissions: [] }
      if (to.meta.title) document.title = to.meta.title
      next()
    }, () => {
      // 如果获取简历不成功并且是本地，直接跳转到登录页面
      if (window.location.hostname === 'localhost') {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      }
    }, () => {
      // 如果获取简历不成功并且不是本地调用sso接口后，成功
      if (to.meta.title) document.title = to.meta.title
      next()
    },
      // 如果获取简历不成功并且不是本地调用sso接口后，不成功，跳单点登录
      goLogin)
  } else {
    // 不需要登录直接访问
    if (to.meta.title) document.title = to.meta.title
    next() // 确保一定要调用 next()
  }
})

const commonFig = {
  el: '#app',
  data: {
    profile: {
      active_company: {},
      join_companys: []
    }
  },
  router,
  store,
  methods: {
    getProfile() {
      let params = this.$route.params
      window.profileLoading = true
      // 如果导航钩子里面已经取到了profile，则直接取导航钩子里面的profile
      if (params && params.profile) {
        this.profile = params.profile
        window.profileLoading = false
      } else {
        // 获取简历
        profileFn((resp) => {
          this.profile = resp.profile
        }, () => { this.profile = {} }, this.getProfile)
      }
    },
    reSearchProfile() {
      profileFn((resp) => {
        this.profile = resp.profile
      }, () => { this.profile = {} }, this.getProfile)
    }
  },
  created() {
    // this.getProfile()
  }
}
export default commonFig
